import styles from "./List.module.css";
import exit from "../../../assets/icons/exit.svg";

export default function List({ services, onServiceAdd, onServiceRemove }) {
    return (
        <div
            className={`${styles.container}  ${
                styles[services.find((el) => el.value > 0) && `active`]
            }`}
        >
            <div className={styles[`service-label`]}>
                <div className={styles[`service-name`]}>Vrsta usluge</div>
                <div className={styles[`service-option-label`]}>
                    Broj uređaja
                </div>
            </div>
            <div
                className={`${styles.devider} ${
                    styles[
                        !services.find((el) => el.value > 0)
                            ? `devider-inactive`
                            : `devider-active`
                    ]
                }`}
            />
            <div className={`${styles.list}`}>
                {services.map((service, index) => {
                    return (
                        <div key={index} className={styles[`service-wrapper`]}>
                            <div
                                className={`${styles.service} ${
                                    styles[
                                        service.value === 0
                                            ? `service-inactive`
                                            : `service-active`
                                    ]
                                }`}
                                style={{
                                    animationDelay: `${index * 0.2}s`,
                                }}
                            >
                                <div className={styles[`service-name`]}>
                                    {service.name}
                                </div>
                                <div className={styles.actions}>
                                    <div
                                        className={styles[`change-button`]}
                                        onClick={() => onServiceRemove(service)}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 100 100"
                                            className={styles.icon}
                                        >
                                            <line
                                                x1="30"
                                                y1="50"
                                                x2="70"
                                                y2="50"
                                                stroke="currentColor"
                                                strokeWidth="10"
                                            />
                                        </svg>
                                    </div>
                                    <div className={styles[`service-option`]}>
                                        {service.value}
                                    </div>
                                    <div
                                        className={styles[`change-button`]}
                                        onClick={onServiceAdd}
                                        value={service.name}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 100 100"
                                            className={styles.icon}
                                        >
                                            <line
                                                x1="50"
                                                y1="20"
                                                x2="50"
                                                y2="80"
                                                stroke="currentColor"
                                                strokeWidth="10"
                                            />
                                            <line
                                                x1="20"
                                                y1="50"
                                                x2="80"
                                                y2="50"
                                                stroke="currentColor"
                                                strokeWidth="10"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    className={styles[`remove`]}
                                    onClick={() =>
                                        onServiceRemove(service, true)
                                    }
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                        className={styles.icon}
                                    >
                                        <line
                                            x1="15"
                                            y1="10"
                                            x2="85"
                                            y2="90"
                                            stroke="currentColor"
                                            strokeWidth="10"
                                        />
                                        <line
                                            x1="85"
                                            y1="10"
                                            x2="15"
                                            y2="90"
                                            stroke="currentColor"
                                            strokeWidth="10"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <div
                                className={`${styles.devider} ${
                                    styles[
                                        service.value === 0
                                            ? `devider-inactive`
                                            : `devider-active`
                                    ]
                                }`}
                                style={{
                                    animationDelay: `${index * 0.2 + 0.1}s`,
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
